import { Type, Service } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Service()
export class SnackService {
  readonly currentSnack = new ReplaySubject<Type<unknown> | undefined>(1);

  showSnack(componentType: Type<unknown>) {
    this.currentSnack.next(componentType);
  }

  destroySnack() {
    this.currentSnack.next(undefined);
  }
}
